// extracted by mini-css-extract-plugin
export default {"slider":"SliderMission_slider__eHjkE","menu":"SliderMission_menu__MsgXs"};